// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import tr from 'date-fns/locale/tr';

import Login from './components/Login';
import MainLayout from './components/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import Musteriler from './components/Musteriler';
import MusteriDetay from './components/MusteriDetay';
import Araclar from './components/Araclar';
import AracDetay from './components/AracDetay';
import Garaj from './components/Garaj';
import Raporlar from './components/Raporlar';
import IsEmriOlustur from './components/IsEmriOlustur';
import IsEmirleri from './components/IsEmirleri';
import IsEmriDetay from './components/IsEmriDetay';
import CariHesaplar from './components/CariHesaplar';
import CariHesapEkstresi from './components/CariHesapEkstresi';
import Randevular from './components/Randevular';
import RandevuListesi from './components/RandevuListesi';
import RandevuDetay from './components/RandevuDetay';
import PreInterviews from './pages/PreInterviews';
import PreInterviewForm from './pages/PreInterviewForm';
import Ayarlar from './pages/ayarlar';
// NOT (K2, Faz 6): Dahili garanti modülü emekliye ayrıldı. Garanti işlemleri
// harici Solar Gard sayfasında yürür (MainLayout menüsünde dış link).
// `warranties` koleksiyonu Firestore'da DOKUNULMADAN duruyor (silme yok).

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
        <AuthProvider>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/*" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="musteriler" element={<Musteriler />} />
                <Route path="musteri/:id" element={<MusteriDetay />} />
                <Route path="araclar" element={<Araclar />} />
                <Route path="arac/:id" element={<AracDetay />} />
                <Route path="garaj" element={<Garaj />} />
                <Route path="on-gorusme" element={<PreInterviews />} />
                <Route path="on-gorusme/yeni" element={<PreInterviewForm />} />
                <Route path="on-gorusme/duzenle/:id" element={<PreInterviewForm />} />
                <Route path="randevular" element={<Randevular />} />
                <Route path="randevular/liste" element={<RandevuListesi />} />
                <Route path="randevu/:id" element={<RandevuDetay />} />
                <Route path="raporlar" element={<Raporlar />} />
                <Route path="is-emri-olustur" element={<IsEmriOlustur />} />
                <Route path="is-emirleri" element={<IsEmirleri />} />
                <Route path="is-emri/:id" element={<IsEmriDetay />} />
                <Route path="is-emri/duzenle/:id" element={<IsEmriOlustur />} />
                <Route path="cari-hesaplar" element={<CariHesaplar />} />
                <Route path="cari-hesaplar/:id" element={<CariHesapEkstresi />} />

                {/* Ayarlar Rotası */}
                <Route path="ayarlar" element={
                  <ProtectedRoute allowedRoles={['Genel Müdür', 'Müdür']}>
                    <Ayarlar />
                  </ProtectedRoute>
                } />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;